const set = require('lodash/fp/set');
const moment = require('moment');

module.exports = angular.module('msi.shipments.subscriptionOrchestrator', [
  require('@ordergroove/brandy/src/app/cookies'),
  require('@ordergroove/brandy/src/app/subscriptions/service'),
  require('@ordergroove/brandy/src/app/shipments/shipments-orchestrator.service')
]).name;

const inject = [
  'cookiesService',
  'subscriptionService',
  'ogsdk.subscriptionService',
  'ogsdk.productService',
  'ogsdk.orderService',
  'shipmentOrchestrator',
  'Frequency'
];

class subscriptionOrchestrator {
  constructor(
    cookiesService,
    legacySubscriptionService,
    subscriptionService,
    productService,
    orderService,
    shipmentOrchestrator,
    Frequency
  ) {
    this.cookiesService = cookiesService;
    this.legacySubscriptionService = legacySubscriptionService;
    this.subscriptionService = subscriptionService;
    this.productService = productService;
    this.orderService = orderService;
    this.shipmentOrchestrator = shipmentOrchestrator;
    this.Frequency = Frequency;
  }

  get(subscriptionId) {
    return this.subscriptionService.get(subscriptionId).then((subscription) => {
      subscription.frequency = this.Frequency.fromBase(subscription.frequency);
      return this.productService.get(subscription.productId, { cache: true })
        .then(product => set('product', product, subscription));
    });
  }

  getNthNextOrderDate(subscription, n = 1) {
    if (n < 1 || n !== Math.floor(n)) {
      throw new Error('n must be positive integer');
    }

    const query = {
      status: [1, 6],
      ordering: 'place',
      subscription: subscription.publicId
      // BE also checks for after today. redudant?
    };

    return this.orderService.getAll(query).then(([nextOrder]) => {
      return moment(nextOrder.place).add((n - 1) * subscription.frequency.freqDays, 'days').toDate();
    });
  }

  cancel(subscriptionId, cancelReason) {
    return this.subscriptionService.cancel(subscriptionId, cancelReason)
      .then(this.shipmentOrchestrator.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }

  reactivateSubscription(subscription) {
    return this.legacySubscriptionService.reactivateSubscription(subscription)
      .then(this.shipmentOrchestrator.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }

  changeNextOrderDate(subscriptionId, nextOrderDate) {
    return this.legacySubscriptionService.changeNextOrderDate(subscriptionId, nextOrderDate)
      .then(this.shipmentOrchestrator.getUnsentShipments)
      .then(this.cookiesService.removeOgImpulseCookie);
  }
}

subscriptionOrchestrator.$inject = inject;

angular.module(module.exports).service('subscriptionOrchestrator', subscriptionOrchestrator);
